import styled from "@emotion/styled";

export const Root = styled.div`
  padding: 0 20px;
  display: grid;
  gap: 24px;
`;

export const CardStyled = styled.div`
  display: flex;
  background-color: white;
  border: 1px solid #e7e9ed;
  border-radius: 16px;
  width: 100%;
  min-height: 122px;
`;

export const CardItem = styled.div<{ isBorder?: boolean }>`
  padding: 24px;
  flex: auto;
  border-right: 1px solid ${(props) => (props.isBorder ? "#E7E9ED" : "white")};
  display: grid;
  align-content: space-between;
`;

export const CardTitle = styled.p`
  font-weight: 700;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: -0.2px;
  vertical-align: middle;
  color: #74849c;
`;

export const CardValue = styled.p`
  font-family: Inter;
  font-weight: 700;
  font-size: 36px;
  line-height: 140%;
  letter-spacing: 0px;
  color: #395278;
`;

export const CardStatus = styled.div<{ bg: string; color: string }>`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 8px 12px;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0px;
  color: ${(props) => props.color};
  background: ${(props) => props.bg};
  border-radius: 100px;
`;
